import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { adminGuard } from './shared/guards/admin.guard';

// All other components are lazy loaded to reduce initial bundle size
// Only Home is eagerly loaded as it's the main entry point

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '',
    children: [
      {
        path: 'home',
        component: Home
      },
      {
        path: 'home/:entityId',
        component: Home
      },
      {
        path: 'reciclar',
        loadComponent: () => import('./components/reciclar/reciclar.component').then(m => m.ReciclarComponent)
      },
      {
        path: 'material',
        loadComponent: () => import('./components/material/material').then(m => m.MaterialComponent)
      },
      {
        path: 'material/:materialId',
        loadComponent: () => import('./components/material/material').then(m => m.MaterialComponent)
      },
      {
        path: 'profile',
        loadComponent: () => import('./components/profile/profile').then(m => m.ProfileComponent)
      },
      {
        path: 'moderation',
        loadComponent: () => import('./components/moderation/moderation.page').then(m => m.ModerationPage)
      },
      {
        path: 'mapa',
        component: Home
      },
      {
        path: 'consejos',
        component: Home
      }
    ]
  },
  // Pages outside tabs (not cached, destroyed on back navigation)
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadComponent: () => import('./components/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent)
  },
  {
    path: 'admin/points',
    canActivate: [adminGuard],
    loadComponent: () => import('./components/admin-points/admin-points.component').then(m => m.AdminPointsComponent)
  },
  {
    path: 'admin/users',
    canActivate: [adminGuard],
    loadComponent: () => import('./components/admin-users/admin-users.component').then(m => m.AdminUsersComponent)
  },
  {
    path: 'admin/batch',
    canActivate: [adminGuard],
    loadComponent: () => import('./components/admin-batch/admin-batch.component').then(m => m.AdminBatchComponent)
  },
  {
    path: 'admin/campaigns',
    canActivate: [adminGuard],
    loadComponent: () => import('./components/admin-campaigns/admin-campaigns.component').then(m => m.AdminCampaignsComponent)
  },
  {
    path: 'edit-point',
    loadComponent: () => import('./components/edit-point/edit-point.component').then(m => m.EditEntityComponent)
  },
  {
    path: 'edit-point/:id',
    loadComponent: () => import('./components/edit-point/edit-point.component').then(m => m.EditEntityComponent)
  },
  {
    path: 'new-point',
    loadComponent: () => import('./components/edit-point/edit-point.component').then(m => m.EditEntityComponent)
  },
  {
    path: 'entity-history/:id',
    loadComponent: () => import('./components/entity-history/entity-history.component').then(m => m.EntityHistoryComponent)
  },
  {
    path: 'user-activity',
    loadComponent: () => import('./components/user-activity/user-activity.component').then(m => m.UserActivityComponent)
  },
  {
    path: 'configuration',
    loadComponent: () => import('./components/configuration/configuration.component').then(m => m.ConfigurationComponent)
  },
  {
    path: 'notifications',
    loadComponent: () => import('./components/notifications/notifications.component').then(m => m.NotificationsComponent)
  },
  {
    path: 'edit-markdown',
    loadComponent: () => import('./components/edit-markdown-page/edit-markdown-page.component').then(m => m.EditMarkdownPageComponent)
  },
  {
    path: 'edit-markdown/:id',
    loadComponent: () => import('./components/edit-markdown-page/edit-markdown-page.component').then(m => m.EditMarkdownPageComponent)
  },
  {
    path: 'new-article',
    loadComponent: () => import('./components/edit-markdown-page/edit-markdown-page.component').then(m => m.EditMarkdownPageComponent)
  },
  {
    path: 'articulo/:slug',
    loadComponent: () => import('./components/article-page/article-page.component').then(m => m.ArticlePageComponent)
  },
  {
    path: 'edit-material',
    loadComponent: () => import('./components/edit-material/edit-material.component').then(m => m.EditMaterialComponent)
  },
  {
    path: 'edit-material/:id',
    loadComponent: () => import('./components/edit-material/edit-material.component').then(m => m.EditMaterialComponent)
  },
  {
    path: 'new-material',
    loadComponent: () => import('./components/edit-material/edit-material.component').then(m => m.EditMaterialComponent)
  },
  {
    path: 'edit-campaign',
    loadComponent: () => import('./components/edit-campaign/edit-campaign.component').then(m => m.EditCampaignComponent)
  },
  {
    path: 'edit-campaign/:id',
    loadComponent: () => import('./components/edit-campaign/edit-campaign.component').then(m => m.EditCampaignComponent)
  },
  {
    path: 'signup',
    loadComponent: () => import('./components/signup/signup.component').then(m => m.SignupComponent)
  },
  {
    path: 'perfil',
    redirectTo: 'profile'
  },
  // Language-prefixed routes — mirror main content routes for i18n prerender & SEO.
  // TranslationService detects the /{lang} prefix in the URL and sets language accordingly.
  ...(['en', 'pt', 'fr', 'it', 'de', 'ar'] as const).map(lang => ({
    path: lang,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' as const },
      { path: 'home', component: Home },
      { path: 'home/:entityId', component: Home },
      {
        path: 'reciclar',
        loadComponent: () => import('./components/reciclar/reciclar.component').then(m => m.ReciclarComponent)
      },
      {
        path: 'material',
        loadComponent: () => import('./components/material/material').then(m => m.MaterialComponent)
      },
      {
        path: 'material/:materialId',
        loadComponent: () => import('./components/material/material').then(m => m.MaterialComponent)
      },
      {
        path: 'mapa',
        component: Home
      },
      {
        path: 'consejos',
        component: Home
      },
      {
        path: 'articulo/:slug',
        loadComponent: () => import('./components/article-page/article-page.component').then(m => m.ArticlePageComponent)
      },
      {
        path: 'profile',
        loadComponent: () => import('./components/profile/profile').then(m => m.ProfileComponent)
      },
      {
        path: 'configuration',
        loadComponent: () => import('./components/configuration/configuration.component').then(m => m.ConfigurationComponent)
      },
      { path: '**', redirectTo: 'home' }
    ]
  })),
  // Spanish is the default language — /es just redirects to root
  {
    path: 'es',
    redirectTo: 'home'
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];
